import cn from '@/lib/cs';
import React from 'react';

const StarIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="m13.3 1 3 5.2 5.8 1 .9 3-4 4.2.7 5.8-2.4 1.8-5.3-2.6L6.7 22l-2.3-1.7.8-6L1 10.1l1-3 5.8-.8L10.6 1h2.7Z"
		/>
	</svg>
);

export default StarIcon;
